import { useWorkflows, useLatestWorkflow, useSetLatestWorkflow } from '@/hooks/use-settings'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { Badge } from '@/components/ui/badge'

export function WorkflowSettings() {
  const { data: workflows, isLoading: workflowsLoading } = useWorkflows()
  const { data: latestWorkflow, isLoading: latestLoading } = useLatestWorkflow()
  const setLatest = useSetLatestWorkflow()

  const isLoading = workflowsLoading || latestLoading

  const handleWorkflowChange = (workflowId: string) => {
    setLatest.mutate(workflowId)
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Default Workflow</CardTitle>
        <CardDescription>
          Select the workflow used for new file processing
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-4">
            <div className="h-16 bg-muted animate-pulse rounded" />
            <div className="h-16 bg-muted animate-pulse rounded" />
            <div className="h-16 bg-muted animate-pulse rounded" />
          </div>
        ) : (
          <RadioGroup
            value={latestWorkflow?.id}
            onValueChange={handleWorkflowChange}
            className="space-y-3"
          >
            {workflows?.map((workflow) => (
              <div
                key={workflow.id}
                className="flex items-center space-x-3 rounded-lg border p-4 hover:bg-muted/50 transition-colors"
              >
                <RadioGroupItem value={workflow.id} id={workflow.id} />
                <Label
                  htmlFor={workflow.id}
                  className="flex-1 cursor-pointer"
                >
                  <div className="flex items-center gap-2">
                    <span className="font-medium">{workflow.name}</span>
                    {workflow.id === latestWorkflow?.id && (
                      <Badge variant="outline">Current</Badge>
                    )}
                  </div>
                  <p className="text-sm text-muted-foreground">
                    {workflow.description}
                  </p>
                </Label>
              </div>
            ))}
          </RadioGroup>
        )}
      </CardContent>
    </Card>
  )
}
